import React from 'react';

interface ItalicIconProps {
    color?: string;
    width?: number;
    height?: number;
}

const ItalicIcon: React.FC<ItalicIconProps> = ({
    color = '#212529',
    width = 12,
    height = 12
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
        >
            <path
                d="M11.25 1.25V0H3.125V1.25H6.3375L3.60625 10H0V11.25H8.125V10H4.9125L7.64375 1.25H11.25Z"
                fill={color}
            />
        </svg>
    );
};

export default ItalicIcon;
